exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0;padding:0;font-family:sans-serif;background-color:#000;overflow:hidden}div{box-sizing:border-box}#futusign_youtube{position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/index.css
// module id = 483
// module chunks = 1